import { createContext, useContext } from 'react';

export const APP_CONTEXT_VALUE = { isAppContext: true };

export const AppContext = createContext<{ isAppContext?: boolean }>({});

export const useAppContext = () => useContext(AppContext);
